@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.footer {
    border-top: 1px solid var(--color-silver);
    padding: 1.875rem 0;

    @include breakpoint.breakpoint(layout.$aboveLargeLine) {
        display: flex;
        flex-wrap: wrap;
    }
}

.toTopLink {
    color: var(--color-lobster);
    display: block;
    font-size: 0.75rem;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    margin: 0 0 3rem;
}
